import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { AuthState } from "@/redux/slice/auth/types/AuthState";
import { ThunkResolvedStatus } from "@/libs/enum/ThunkResolvedStatus";
import authSignOut from "@/redux/slice/auth/thunks/authSignOut";

const authSignOutBuilder = (builder: ActionReducerMapBuilder<AuthState>): void => {
  builder
    .addCase(authSignOut.pending, (state) => {
      state.thunkStatus.authSignOut = ThunkResolvedStatus.pending;
    })
    .addCase(authSignOut.fulfilled, (state, action) => {
      state.thunkStatus.authSignOut = ThunkResolvedStatus.fulfilled;
    })
    .addCase(authSignOut.rejected, (state) => {
      state.thunkStatus.authSignOut = ThunkResolvedStatus.rejected;
    });
};

export default authSignOutBuilder;
